import { useState, useEffect, useCallback } from 'react';
import { getCredits } from '../services/api';
import { useAuth } from './useAuth';

export const useCredits = () => {
  const { isAuthenticated } = useAuth();
  const [credits, setCredits] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCredits = useCallback(async () => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const data = await getCredits();
      setCredits(data.credits);
      setError(null);
    } catch (err: any) {
      setError(err.message || 'Failed to fetch credits');
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    fetchCredits();
  }, [fetchCredits]);

  return {
    credits,
    loading,
    error,
    refetch: fetchCredits
  };
};

